import React, { createContext, useContext } from 'react';
import { useLanguage } from '../hooks/useLanguage';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const languageUtils = useLanguage();

  return (
    <LanguageContext.Provider value={languageUtils}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguageContext = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguageContext must be used within a LanguageProvider');
  }
  return context;
}; 